import * as React from "react"
import { Badge, Button, Col, Row, Tabs, Tag } from "antd"
import { withTranslation, WithTranslation } from 'react-i18next'
import EmployeesManagementList from 'src/pages/admin/management/employee-management-list'
import ProjectsManagementList from 'src/pages/admin/management/project-management-list'
import EligibilityManagementList from 'src/pages/admin/management/eligibility-management-list'
import TotalsReportView from 'src/pages/admin/management/totals-report'
import autobind from 'autobind-decorator'
import Tour from 'reactour'
import steps from 'src/components/virtual-tour/virtual-tour-configs'
import EditableTooltip from './editable-tooltip/tooltip'
import { UserProfile, UserProfileProps, withUserProfile } from "./user-profile"


// tslint:disable-next-line:no-empty-interface
interface ReportTabViewProps extends WithTranslation, UserProfileProps {
    companyName: string
    companyId: string
    isAdmin: boolean
    employeeId?: string
    currency: string
    allowCir: boolean
    allowCii: boolean
    isManager: boolean
}

interface ReportTabViewState {
    isTourOpen: boolean
    activeTabKey: any
}

class ReportTabView extends React.Component<ReportTabViewProps, ReportTabViewState> {

    constructor(props: ReportTabViewProps) {
        super(props)
        this.state = {
            isTourOpen: false,
            activeTabKey: "employeesManagement"
        }
    }

    @autobind
    private setIsTourOpen(state: boolean) {
        this.setState({ isTourOpen: state })
    }

    handleTabChange = (activeTabKey: string) => {
        this.setState({ activeTabKey })
    }

    public render() {
        const { t, isAdmin, employeeId, isManager } = this.props
        const { activeTabKey } = this.state
        const isFutureAllowes = this.props.userProfile.companies.firstOrDefault(x => x.companyId == this.props.companyId)?.isFutureAllowed || false
        var stepsReports = steps(t).stepsReports
        // Remove employee selection section
        if (activeTabKey == "employeesManagement") {
            var stepsReports = steps(t).stepsReports
        } else if (activeTabKey == "projectsManagement") {
            var stepsReports = steps(t).stepsReportsProjects
        } else {
            var stepsReports = steps(t).stepsReportseligibilitye
        }

        if (!isAdmin) {
            stepsReports.splice(1, 1)
            stepsReports.splice(2, 1)
        }
        return <div>
            <Row gutter={0} >
                <Col span={12}>
                    <Tour
                        steps={stepsReports}
                        isOpen={this.state.isTourOpen}
                        onRequestClose={() => this.setIsTourOpen(false)}
                    />
                </Col>
                <Col span={12}>
                    <Button data-tut="reactour__reportInit" type={"link"} style={{ float: 'right', marginBottom: 5 }} onClick={() => this.setIsTourOpen(true)} icon={'caret-right-fill'}>  {t("Discover Reports")} </Button>
                </Col>
            </Row>
            <div >
                <Tabs
                    activeKey={activeTabKey}
                    onChange={this.handleTabChange}
                    style={{ marginLeft: -10 }}
                    tabBarStyle={{ maxWidth: '180px' }}
                    tabPosition={"left"}>
                    <Tabs.TabPane key="employeesManagement" tab={<div data-tut={!isAdmin ? "reactour__navegateMyReports" : "reactour__navegateReport"} style={{ textAlign: 'left', fontSize: '13.2px' }}>{t("By Employees")}</div>}>
                        <EmployeesManagementList key={this.props.companyId} isAdmin={isAdmin} companyId={this.props.companyId} isManager={isManager} />
                    </Tabs.TabPane>

                    <Tabs.TabPane key="projectsManagement" tab={<div style={{ textAlign: 'left', fontSize: '13.2px' }}>{t("By Project")}</div>}>
                        <ProjectsManagementList key={this.props.companyId} companyName={this.props.companyName} companyId={this.props.companyId} isAdmin={isAdmin} employeeId={employeeId} />
                    </Tabs.TabPane>

                    <Tabs.TabPane key="eligibilityeManagement"
                        tab={<div style={{ whiteSpace: 'break-spaces', overflow: 'visible', textAlign: 'left', fontSize: '13.2px' }}>
                            <EditableTooltip name='report-tab-eligibility'>
                                {t("By Eligibility")}
                            </EditableTooltip>
                        </div>
                        }
                    >
                        <EligibilityManagementList
                            key={this.props.companyId}
                            currency={this.props.currency}
                            companyName={this.props.companyName}
                            companyId={this.props.companyId}
                            isAdmin={isAdmin}
                            employeeId={employeeId}
                            allowCir={this.props.allowCir}
                            allowCii={this.props.allowCii} />
                    </Tabs.TabPane>
                    {isFutureAllowes && < Tabs.TabPane key="totals" tab={<div style={{ textAlign: 'left', fontSize: '13.2px' }}>{t("Custom Totals")}</div>}>
                        <TotalsReportView isAdmin={isAdmin} companyId={this.props.companyId}></TotalsReportView>
                    </Tabs.TabPane>}
                </Tabs>
            </div>

        </div>
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withTranslation()(ReportTabView))
